import React from "react";
import PropTypes from "prop-types";
import { twMerge } from "tailwind-merge";

import { useUser } from "../contexts/user";
import ChampPointsStamp from "./ChampPointsStamp";
import { useTransmogrifier } from "../contexts/Transmogrifier";
import { useCurrentChampion } from "../hooks";

export default function ChampPointsVideoLabel({ className, points }) {
  const { user } = useUser();
  const currentChampion = useCurrentChampion();
  const { points: transmogrifierPoints } = useTransmogrifier();

  if (!currentChampion) {
    return null;
  }

  return (
    <div className={twMerge("text-white flex items-center", className)}>
      <ChampPointsStamp
        className={twMerge(
          "mr-2 mb-1",
          transmogrifierPoints >= currentChampion.pointsPerLevel && "grayscale",
        )}
        points={points}
        size="lg"
      />

      {currentChampion.reachedMaxLevel ? (
        <p className="text-xs sm:text-sm">
          Level up and choose a new champ
          <br />
          to continue earning points.
        </p>
      ) : transmogrifierPoints >= currentChampion.pointsPerLevel ? (
        <p className="text-xs sm:text-sm">
          {user.isLoggedIn ? "Level up your champ" : "Create a Free Account"}
          <br />
          to continue earning points.
        </p>
      ) : (
        <p className="text-xs sm:text-sm">
          Watch this video to
          <br />
          earn {points === 1 && "a"} point{points > 1 && "s"} for your champ!
        </p>
      )}
    </div>
  );
}

ChampPointsVideoLabel.propTypes = {
  className: PropTypes.string,
  points: PropTypes.number.isRequired,
};

ChampPointsVideoLabel.defaultProps = {
  className: undefined,
};
